import { useCallback } from 'react';

import ClipboardDocumentCheckIcon from '@heroicons/react/24/outline/ClipboardDocumentCheckIcon';
import { Button } from 'atp-react-ui';
import { useLocation, useNavigate } from 'react-router';

import { ROUTES } from '@/_navigation';
import {
  removePracticeExamAPIs,
  removePracticeExamChildren,
} from '@/_other-pages/practice-exams/practice-exam-setup/shared';
import { useGetPurchasedPracticeExamsMutation } from '@/_other-pages/practice-exams/purchased/shared';
import { googleAnalytics4 } from '@/_services';

export function PracticeExamButton({ practice_exam_id }: { practice_exam_id: string }) {
  const { pathname } = useLocation();
  const { mutateAsync, isPending } = useGetPurchasedPracticeExamsMutation();

  const nav = useNavigate();

  const handleStartAssessment = useCallback(async () => {
    sessionStorage.clear();
    removePracticeExamAPIs();
    removePracticeExamChildren(parseInt(practice_exam_id));
    const response = await mutateAsync(practice_exam_id ?? '');

    if (response) {
      googleAnalytics4.event({
        category: 'Practice Exam',
        action: 'Start Assessment',
      });
      nav(ROUTES.PRACTICE_EXAM_SETUP.path, {
        state: {
          from: pathname,
          practiceExam: { ...response },
          naturalBack: true,
        },
      });
    }
  }, [practice_exam_id, mutateAsync, nav, pathname]);

  return (
    <Button
      as="link"
      block
      className="justify-between px-4"
      onClick={handleStartAssessment}
      iconRight={ClipboardDocumentCheckIcon}
      showLoader={isPending}
    >
      Practice Exam
    </Button>
  );
}
